import { render, staticRenderFns } from "./horizontalTable.vue?vue&type=template&id=987a6e24&scoped=true&"
import script from "./horizontalTable.vue.js?vue&type=script&lang=js&"
export * from "./horizontalTable.vue.js?vue&type=script&lang=js&"
import style0 from "./horizontalTable.vue?vue&type=style&index=0&id=987a6e24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a6e24",
  null
  
)

export default component.exports